<template>
  <!-- 法律知识文章页，罪名库文章页 -->
  <div class="lawsarticl">
    <div class="cont between">
      <div class="left">
        <lawsardet class="compon" />
        <zmlawtj class="compon mt30" />
        <lawdetmorexg class="compon mt30" />
      </div>
      <div class="right">
        <zuimintj
          class="compon"
          tjtitle="刑法指南"
          moniwx="请律师打官司作用和重要性"
        />
        <lawdettyls class="compon mt30" />
        <lawdetzz class="compon mt30" />
        <lawdetxghd class="compon mt30" />
        <lawdettli class="compon mt30" />
      </div>
    </div>
  </div>
</template>

<script>
import lawsardet from "./child/lawsardet";
import zmlawtj from "views/zuimindetail/components/zmlawtj";
import lawdetmorexg from "./child/lawdetmorexg";
import zuimintj from "views/zuiminlist/components/zuimintj";
import lawdettyls from "./child/lawdettyls";
import lawdetzz from "./child/lawdetzz";
import lawdetxghd from "./child/lawdetxghd";
import lawdettli from "./child/lawdettli";
export default {
  name: "lawsarticl",
  components: {
    lawsardet,
    zmlawtj,
    lawdetmorexg,
    zuimintj,
    lawdettyls,
    lawdetzz,
    lawdetxghd,
    lawdettli,
  },
};
</script>

<style lang="scss" scoped>
.lawsarticl {
  padding: 50px 0;
  background: #f8f8f8;
  .cont {
    align-items: flex-start;
    width: 1200px;
    margin: 0 auto;
    .compon {
      width: 100%;
      background: #ffffff;
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
      border-radius: 2px;
    }
    .left {
      width: 856px;
    }
    .right {
      width: 314px;
    }
  }
}
</style>